import { render, staticRenderFns } from "./f_files.vue?vue&type=template&id=a09fd79a&scoped=true&"
import script from "./f_files.vue?vue&type=script&lang=js&"
export * from "./f_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09fd79a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a09fd79a')) {
      api.createRecord('a09fd79a', component.options)
    } else {
      api.reload('a09fd79a', component.options)
    }
    module.hot.accept("./f_files.vue?vue&type=template&id=a09fd79a&scoped=true&", function () {
      api.rerender('a09fd79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/f_exchange/f_files.vue"
export default component.exports